import React from 'react'
import PropTypes from 'prop-types'
import i18n from './context' // Our custom context

/**
 * @returns {React.PureComponent} Component with locales as proptypes
 */
export default function setLanguageFromPage() {
  return WrappedComponent => {
    //console.log('i18n : ', i18n)
    return class extends React.PureComponent {
      static propTypes = {
        pageContext: PropTypes.shape({
          language: PropTypes.string.isRequired
        })
      }

      componentDidMount() {
        const currentLanguage = i18n.language
        const pageLanguage = this.props.pageContext.language

        // First request
        if (!currentLanguage) {
          i18n.language = pageLanguage
        }

        // Only update on language change
        if (currentLanguage !== pageLanguage) {
          i18n.changeLanguage(pageLanguage)
        }
      }

      render() {
        return <WrappedComponent {...this.props} />
      }
    }
  }
}
